import { render } from "./JwstBrick.vue?vue&type=template&id=3f4c084c&ts=true"
import script from "./JwstBrick.vue?vue&type=script&lang=ts"
export * from "./JwstBrick.vue?vue&type=script&lang=ts"

import "./JwstBrick.vue?vue&type=style&index=0&id=3f4c084c&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__